export const DEFAULT_CELL_WIDTH = 120;
